
import { defineComponent, PropType, reactive, onMounted, watch } from 'vue'
import { useStore } from 'vuex'

import { RepositoryFactory } from '@/repositories/RepositoryFactory'
const TeamRepository = RepositoryFactory.get('team')
const CategoryRepository = RepositoryFactory.get('category')

import { Team } from '@/types/team'
import { TeamCategory } from '@/types/teamCategory'
import { Player } from '@/types/player'

import _ from 'lodash.clonedeep'

export default defineComponent({
  inheritAttrs: false,
  components: {
  },
  props: {
    teamData: {
      type: Object as PropType<Team>
    }
  },
  setup(props) {
    const store = useStore()

    onMounted(() => {
      getTeamCategories()
    })

    const team: {
      data?: Team
      selectedPlayer?: Player
    } = reactive({
      data: undefined,
      selectedPlayer: undefined
    })

    watch(
      () => props.teamData,
      () => {
        team.data = _(props.teamData)
      },
      { immediate: true, deep: true }
    )

    const teamInformationForm = reactive({
      isCompleted: false
    })

    watch(
      () => [team.data?.name, team.data?.short_name],
      () => {
        teamInformationForm.isCompleted = (team.data?.name !== '' && team.data?.short_name) ? true : false
      },
      { immediate: true }
    )

    const teamCategories: {
      list: TeamCategory[]
    } = reactive({
      list: []
    })

    const getTeamCategories = async () => {
      try {
        const res = await CategoryRepository.getTeamCategories()

        if (res.status === 200) {
          const r = res.data
          const data = r.data

          teamCategories.list = data.categories
        }
      } catch (error) {
        //
      }
    }

    const updateTeam = async () => {
      try {
        const dataObj = {
          team_id: team.data?.id,
          category_id: team.data?.category_id,
          name: team.data?.name,
          short_name: team.data?.short_name
        }

        const res = await TeamRepository.updateTeam(dataObj)

        if (res.status === 200) {
          store.dispatch('addFlashMessage', {
            type: 'success',
            message: 'チーム情報を変更しました'
          })
        }
      } catch (error) {
        //
      }
    }

    return {
      team,

      teamCategories,
      getTeamCategories,

      teamInformationForm,
      updateTeam
    }
  }
})
